import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {ErrorSubMessages, ErrorToastData, ToastId} from '@mintdata-wsp/common/state/ui/visualDesigner/ToastData';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {ErrorSubMessageSupport} from '@mintdata-wsp/wsp/ui/components/toasts/errorSubMessages/ErrorSubMessageSupport';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ErrorToast.less');
const cx = classnames.bind(styles);

export interface IErrorToastProps
{
    toast:ErrorToastData;
    onClose:(toastId:ToastId) => void;
}

function getErrorSubMessageComponentByEnumType(type:ErrorSubMessages)
{
    if( type === ErrorSubMessages.Support )
        return <ErrorSubMessageSupport />;

    return '';
}

@observer
export class ErrorToast extends React.Component<IErrorToastProps>
{
    @observable
    private _isStackTraceOpen:boolean = false;

    @bind
    private _reloadApplication()
    {
        window.location.reload();
    }

    @action.bound
    private _toggleStackTraceVisibility()
    {
        this._isStackTraceOpen = !this._isStackTraceOpen;
    }

    @bind
    private _closeToast()
    {
        const {toast, onClose} = this.props;

        onClose(toast.id);
    }

    @bind
    private _renderToastSubMessage()
    {
        const {toast} = this.props;

        if( (Object.values(ErrorSubMessages) as string[]).includes(toast.subMessage) )
            return getErrorSubMessageComponentByEnumType(toast.subMessage as ErrorSubMessages);

        return toast.subMessage;
    }

    public render():JSX.Element
    {
        const {toast} = this.props;

        return <div className={styles.base}>
            <div className={styles.messageWrapper}>
                <MDIcon name={MDIcons.common.Info} className={styles.icon} />
                {toast.count > 1 ? <div className={styles.errorsCount}>{toast.count}</div> : null}
                <div className={styles.message}>
                    <p className={styles.toastMessage}>{toast.message}</p>
                    <p className={styles.toastSubMessage}>{this._renderToastSubMessage()}</p>
                </div>
            </div>
            <div className={styles.buttonsWrapper}>
                {toast.stackTrace
                    ? <button
                        onClick={this._toggleStackTraceVisibility}
                        className={styles.collapseButton}
                    >
                        <MDIcon
                            name={MDIcons.common.ChevronRight}
                            className={cx('collapseIcon', {isOpen: this._isStackTraceOpen})}
                        />
                        Stack trace
                    </button>
                    : <div className={styles.placeholder} />}
                <WSPButton
                    onClick={this._reloadApplication}
                    className={styles.reloadButton}
                    icon={MDIcons.common.Refresh}
                    style={ButtonStyle.Raised}
                    caption="Reload Page"
                />
            </div>
            {this._isStackTraceOpen && <pre className={styles.stackTrace}>
                    {toast.stackTrace || toast.message}
            </pre>}
            <WSPButton
                icon={MDIcons.common.Close}
                style={ButtonStyle.SimpleSecondary}
                className={styles.closeBtn}
                onClick={this._closeToast}
            />
        </div>;
    }
}
